import { Component, Input, EventEmitter, Output } from '@angular/core';


@Component({
  selector: 'ae-toast',
  templateUrl: './ae-toast.component.html',
  styleUrls: ['./ae-toast.component.scss'],
})
export class AeToastComponent {

  @Input()
  message: string = "";

  @Input()
  timeElapsed: number = 0;

  timeRestante: number = 0;

  percentageLoad: number = 100;

  
  intervalID: any = null;

  constructor() {}

  @Output() onClose = new EventEmitter<any>();

  ngOnInit(): void {
    this.percentageLoad = 100;
    this.timeRestante = this.timeElapsed

    this.intervalID = setInterval(() => {
      if (this.timeRestante === 0) {
        clearInterval(this.intervalID)
      } else {
        this.percentageLoad = this.timeRestante / this.timeElapsed * 100
      }
      this.timeRestante -= 50
    }, 50);



    setTimeout(() => {
      this.onClose.emit()
    }, this.timeElapsed);
  }

  public setClose () {
    this.onClose.emit()
  }
 
  
}